export default __webpack_public_path__ + "static/media/16-clustering.c5ef2b1a.svg";